<template>
    <v-col cols="12" sm="12" md="6" class="my-0">
        <v-card>
            <v-card-title class="secondary white--text pa-3" id="card-title">
            <div class="">
                <v-icon class="mr-3" color="white" >mdi-currency-gbp</v-icon>
                <span class="">Financials Settings</span>
            </div>
            </v-card-title>
            <p v-bind:class="{hidden: !this.getHasLettingsError()}" class="errorMessage">Only numeric characters and '.' can be submitted as a lettings forecast</p>
            <p v-bind:class="{hidden: !this.getHasSalesError()}" class="errorMessage">Only numeric characters and '.' can be submitted as a sales forecast</p>
            <v-simple-table>
                <template>
                    <tbody>
                        <tr>
                            <td class="">Lettings Sales Forecast (£):</td>
                            <td class="text-center"><input class="centered-input" v-bind:class="{errorBorder: this.getHasLettingsError()}" style="width:90%" placeholder="Set lettings fee" v-model.lazy="lettingsForecastAmount" v-on:change="changeLettingsForecast()"></td>
                        </tr>
                        <tr>
                            <td class="">Estate Agency Sales Forecast (£):</td>
                            <td class="text-center"><input class="centered-input" v-bind:class="{errorBorder: this.getHasSalesError()}" style="width:90%" placeholder="Set sales fee" v-model.lazy="salesForecastAmount" v-on:change="changeSalesForecast()"></td>
                        </tr>
                    </tbody>
                </template>
            </v-simple-table>
            <p class="description">*Enter your company income forecasts for sales and lettings here. These figures will be used on the <router-link to="/financials">financial dashboard</router-link> to compare your forecasted income against your actual income for the given month. These figures need to be updated every month.</p>
        </v-card>
    </v-col>
</template>
<script>
export default {
  data() {
    return {
        hasLettingsError: false,
        hasSalesError: false
    }
  },
  methods: {
      getHasLettingsError(){
          return this.hasLettingsError;
      },
        getHasSalesError(){
          return this.hasSalesError;
      },
    formatNumber: function (value) {
        if (typeof value !== "number") {
                return value;
        }
            value = value.toLocaleString(
                this.$store.state.currencyData.LocaleCode,
                { minimumFractionDigits: 0 }
            );
        return value;
    },
    changeLettingsForecast(){
        if(isNaN(parseFloat(this.$store.state.Financials.lettingsForecast.amount))){
            this.hasLettingsError = true;
        }
        else{
            if(this.$store.state.Financials.lettingsForecast.id !== 0){
                const payload =  {
                    id: this.$store.state.Financials.lettingsForecast.id,
                    amount: this.$store.state.Financials.lettingsForecast.amount
                }
                this.$store.dispatch('Financials/updateLettingsForecast', payload);
            }
            else{
                const payload = {
                    feeType: "lettings",
                    startDate: this.$store.state.reportMonthStart,
                    endDate: this.$store.state.reportMonthEnd,
                    amount: this.$store.state.Financials.lettingsForecast.amount
                }
                this.$store.dispatch('Financials/createLettingsForecast', payload);
            }
            this.hasLettingsError = false;
        }
    },
    changeSalesForecast(){
        if(isNaN(parseFloat(this.$store.state.Financials.salesForecast.amount))){
            this.hasSalesError = true;
        }
        else{
            if(this.$store.state.Financials.salesForecast.id !== 0){
                const payload = {
                    id: this.$store.state.Financials.salesForecast.id,
                    amount: this.$store.state.Financials.salesForecast.amount
                }
                this.$store.dispatch('Financials/updateSalesForecast', payload);
            }
            else{
                const payload = {
                    feeType: "sales",
                    startDate: this.$store.state.reportMonthStart,
                    endDate: this.$store.state.reportMonthEnd,
                    amount: this.$store.state.Financials.salesForecast.amount
                }
                this.$store.dispatch('Financials/createSalesForecast', payload);
            }
            this.hasSalesError = false;
        }
    }
  },
  computed: {
      lettingsForecastAmount: {
          get(){
            return this.formatNumber(this.$store.state.Financials.lettingsForecast.amount);
          },
          set(newValue){
              this.$store.state.Financials.lettingsForecast.amount = newValue;
          }
        },
       salesForecastAmount: {
          get(){
            return this.formatNumber(this.$store.state.Financials.salesForecast.amount);
          },
          set(newValue){
              this.$store.state.Financials.salesForecast.amount = newValue;
          }
        }
  },
  mounted () {
  },
  created(){
    this.$store.dispatch("Financials/getLettingsForecast");
    this.$store.dispatch("Financials/getSalesForecast");
  },
  watch: {
    '$store.state.reportMonth': function (){
    this.$store.dispatch("Financials/getLettingsForecast");
    this.$store.dispatch("Financials/getSalesForecast");
    }
  }
}
</script>
<style scoped>
.description{
    font-size:10px;
}
</style>
